import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  iban?: string;
};

/**
 * Swan names no amount for the first transfer — any transfer from an account in
 * the company's own name satisfies it — so this only shows where it has to go.
 */
export const FirstTransferBlock: FC<Props> = ({ iban }) => {
  const { t } = useTranslation();

  if (!iban) return null;

  return (
    <div className="mt-2 max-w-[460px] text-sm">
      <p className="m-0">
        <span className="text-grey-600">{t('pxtraCard:firstTransferIban')}: </span>
        <span className="font-mono">{iban}</span>
      </p>
      <p className="m-0 mt-1 text-xs text-grey-600">{t('pxtraCard:firstTransferPending')}</p>
    </div>
  );
};
